const VIMEO_AUTH_URL = 'https://api.vimeo.com/oauth/authorize';

class VimeoSettingsController {
  constructor(VimeoUser, toaster, $state) {
    'ngInject';
    this.VimeoUser = VimeoUser;
    this.toaster = toaster;
    this.$state = $state;

    this.vimeoUsers = [];

    // If this page was loaded with `code`
    const code = $state.params.code;
    if (code) {
      this.addCode(code);
    } else if ($state.params.link) {
      this.linkAccount();
    } else {
      $state.go('settings.integrations');
    }
  }

  addCode(code) {
    const { VimeoUser, toaster, $state } = this;

    // Ask the API to get the token for this code and redirect_uri
    const user = new VimeoUser({ code: code, redirect_uri: VIMEO_OAUTH_REDIRECT });
    const promise = user
      .$save()
      .then((u) => {
        $state.go('settings.integrations', { integration_id: u.id });
      })
      .catch((err) => {
        console.error(err);
        toaster.pop(
          'warning',
          'Unable to link the requested Vimeo account. Please reload this page and try again.'
        );
      });
    this.loadingPromises = [promise];
  }

  linkAccount() {
    const authParams = {
      response_type: 'code',
      client_id: VIMEO_CLIENT_ID,
      redirect_uri: VIMEO_OAUTH_REDIRECT,
      scope: VIMEO_SCOPE,
      state: 'vimeo',
    };
    const queryStr = Object.keys(authParams)
      .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(authParams[k])}`)
      .join('&');
    window.location.replace(`${VIMEO_AUTH_URL}?${queryStr}`);
  }
}

export default VimeoSettingsController;



// WEBPACK FOOTER //
// ./app/pages/settings/vimeo.js